<div class="klab-login-page">
    <div class="login-page__overlay">
        <ui-sec-recover-password [form]="form" [step]="step" [title]="uiConfig[step].title"
            [subtitle]="uiConfig[step].subtitle" [description]="currentDescription"
            [primaryButtonLabel]="uiConfig[step].buttonLabel" [primaryButtonDisabled]="isPrimaryButtonDisabled"
            [showTerms]="uiConfig[step].showTerms" (submitted)="handleSubmitStep()" (resendCode)="handleResendCode()"
            (goBack)="goToLogin()" [showPasswordMismatch]="showPasswordMismatch">
        </ui-sec-recover-password>
    </div>
</div>